'use strict';

angular.module('internal.users')
    .controller('InternalUserExams', [
        '$scope',
        '$stateParams',
        'EXSessions',
        '$state',
        'EXType',
        'EXLocation',
        'LicenseCategoryLevels',
        'Enterprise',
        'Permissions',
        function ($scope, $stateParams, EXSessions, $state, EXType, EXLocation, LicenseCategoryLevels, Enterprise, Permissions) {
            $scope.loading = true;
            $scope.subRecords = 'sessionResults';
            $scope.types = [];
            $scope.locations = [];
            $scope.levels = [];

            Enterprise.get().then(function (enterprise) {
                if (enterprise != null) {
                    Permissions.view('internal.exams.session.details').then(function (access) {
                        $scope.examsModuleOff = !(enterprise.exams_module == null ? false : enterprise.exams_module) || !access;
                    })
                }
            })

            EXSessions.getcandidatesessionresults($stateParams.id).then(function (sessions) {
                $scope.sessions = sessions.records;
                $scope.loading = false;
            });

            EXType.get().then(function (types) {
                types.records.forEach(function (type) {
                    $scope.types.push({ id: type.id, name: type.name })
                });
            });

            EXLocation.get().then(function (locations) {
                locations.records.forEach(function (location) {
                    $scope.locations.push({ id: location.id, name: location.name })
                });
            });

            LicenseCategoryLevels.get({ entity_id: '5384A3C9-A244-41CC-92C1-6423E4561B83' }).then(function (levels) {
                levels.forEach(function (level) {
                    $scope.levels.push({ id: level.id, name: level.combined_name })
                });
            });

            $scope.columns = [
                {
                    label: "Number",
                    field: "number",
                    link: {
                        state: "internal.exams.session.details",
                        params: [
                            {
                                name: "examSessionID",
                                field: "id"
                            }
                        ]
                    }
                }, {
                    label: "Name",
                    field: "name"
                }, {
                    label: "Type",
                    field: "examTypeName"
                }, {
                    label: "Date",
                    field: "date",
                    type: "datetime"
                }, {
                    label: "Location",
                    field: "examLocationName"
                }, {
                    label: "Level",
                    field: "licenseCategoryLevelName"
                }, {
                    label: "Packet",
                    field: "examPacketName"
                }, {
                    label: "Result",
                    field: "passed",
                    type: "passfail"
                }
            ];

            $scope.filters = [
                {
                    name: "Exam Type",
                    field: "examTypeId",
                    options: $scope.types
                },
                {
                    name: "Location",
                    field: "examLocationId",
                    options: $scope.locations
                },
                {
                    name: "Level",
                    field: "licenseCategoryLevelId",
                    options: $scope.levels
                }
            ];

            $scope.subColumns = [
                {
                    label: "Station",
                    field: "examSessionStationName"
                }, {
                    label: "Form",
                    field: "examFormName",
                    documentid: 'documentID',
                    documentcode: 'documentCode'
                }, {
                    label: "Examiner",
                    field: "examinerName"
                }, {
                    label: "Attempt Number",
                    field: "attemptIndex"
                }, {
                    label: "Attempt Date",
                    field: "attemptDate",
                    type: "datetime"
                }, {
                    label: "Attempt Status",
                    field: "passed",
                    type: "passfail"
                }
            ];


        }])
    ;